function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import SelectedItemComponent from '../../../components/Items/SelectedItem/SelectedItem';
import { useDispatch, useSelector } from 'react-redux';
import { dataItemDeselect } from '../../../store/actions/datasetSlice';
import { setHash } from '../../../utils/urlUtils';

/**
 * This component provides the currently selected dataset item if any
 */
function SelectedItem(props) {
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      return state.dataset && state.dataset.selected;
    }),
    loading = _useSelector.loading,
    error = _useSelector.error,
    item = _useSelector.item;
  var handleDeselectItem = function handleDeselectItem() {
    setHash('selectedItem', '');
    dispatch(dataItemDeselect());
  };
  useEffect(function () {
    props.onLoad && props.onLoad(item);
  }, [item]);
  return /*#__PURE__*/React.createElement(SelectedItemComponent, _extends({
    loading: loading,
    error: error,
    item: item,
    deselect: function deselect() {
      return handleDeselectItem();
    }
  }, props));
}
SelectedItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /** A callback method that is called when the item selection is applied */
  onLoad: PropTypes.func,
  /**
   * A render function that is used to display the a UI based on the provided data and methods.  Either the single function as a child this prop should be provided
   * @function
   * @param {Object} props
   * @param {boolean} props.loading A loading state identifier
   * @param {Object} props.error An error object if any
   * @param {Object | null} props.item The currently selected item
   * @param {Object} methods
   * @param {function} methods.deselect A method to call when a the item selection needs to be cleared
   *  */
  render: PropTypes.func
} : {};
export default SelectedItem;